import MediaList from "../MediaList";

export const mediaList = [
    {
        path: "/newMedia/mediaList", //微信榜单
        component: MediaList
    },
];